<sb-table-wrapper (optionsChange)="requestDebounced($event)" [isInIntegratedContext]="true"
                  [itemName]="'culls'"
                  [itemsData]="culls" [loading]="loading" [options]="options"
                  [showExactMatch]="true" headline="{{'lang.headlines.culls' | translate}}">

  <!------------------------------

      Header More

------------------------------->
  <div header-more>
    <sb-button (click)="requestDebounced()" [disabled]="loading" [loading]="loading"
               classes="btn-default actionButtonMinWidth"
               container="body" ngbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top">
      <sb-icon icon="refresh"></sb-icon>
    </sb-button>
    <a *ngPermissions="permissionService.Permission.cull_list"
       [queryParams]="{'company': companyId}" [sbRouterLink]="util.RoutingID.filters">
      <button class="btn btn-primary">{{ 'lang.globals.showInList' | translate }}</button>
    </a>
  </div>
  <!------------------------------

     Table Header

------------------------------->
  <ng-template #thead>
    <tr>
      <th>{{ 'lang.globals.type' | translate }}</th>
      <th>{{ 'lang.globals.title' | translate }}</th>
      <th>{{ 'lang.deviceFilterList.usageCount' | translate }}</th>
      <th>{{ 'lang.globals.modifiedAt' | translate }}</th>
      <th></th>
    </tr>
  </ng-template>

  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-filter>
    <tr>
      <td>
        <ng-container [ngSwitch]="filter.type">
          <sb-icon *ngSwitchCase="'TimeCull'" class="circle" icon="calendar"></sb-icon>
          <sb-icon *ngSwitchCase="'ClientCull'" class="circle" icon="company"></sb-icon>
          <sb-icon *ngSwitchCase="'GeoCull'" class="circle" icon="locationStreet"></sb-icon>
          <sb-icon *ngSwitchCase="'PlayerCull'" class="circle" icon="playerOnline"></sb-icon>
          <sb-icon *ngSwitchCase="'ContentCull'" class="circle" icon="screenPlay"></sb-icon>
        </ng-container>
      </td>
      <td>
        <sb-comp-name-wrapper>
          <sb-comp-link
            [condition]="permissionService.hasPermission(permissionService.Permission.cull_show)"
            [link]="util.RoutingID.filterDetails"
            [pathParams]="[{id: 'filterID', value: filter?.id}]"
            [title]="filter?.name" firstLine>
          </sb-comp-link>
        </sb-comp-name-wrapper>
      </td>
      <td>
        {{ filter?.usageCount }}
      </td>
      <td>
        <sb-comp-display-modified [data]="filter"></sb-comp-display-modified>
      </td>
      <td class="sticky-col last-col tableBg p-2 tr" style="z-index: 1">
        <a *ngIf="permissionService.hasPermission(permissionService.Permission.cull_show)"
           [pathParams]="[{id: 'filterID', value: filter?.id}]"
           [sbRouterLink]="util.RoutingID.filterDetails"
           class="btn btn-primary" container="body"
           ngbTooltip="{{ 'lang.globals.openDetails' | translate }}">
          <sb-icon icon="details"></sb-icon>
        </a>
      </td>
    </tr>
  </ng-template>

</sb-table-wrapper>
